import React, { useState, useRef, useEffect } from 'react';
import './VisitorsBook.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

// --- Data ---

const VISITORS = [
  {
    id: 1,
    name: 'Masaki Osama',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'Visited this incredible place with a team of educators from government welfare schools. It\'s a huge eye opener. Hats off to all the staff under the leadership of Dr. Goud, the Great.',
    category: 'Educator'
  },
  {
    id: 2,
    name: 'Dr. R.S. Praveen Kumar',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'I am completely overwhelmed by your wonderful school as a beautiful happy student. Thank You.',
    category: 'Visitor'
  },
  {
    id: 3,
    name: 'Amanda Milton',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'What a lovely place and Amazing people. Love and Blessings.',
    category: 'Visitor'
  },
  {
    id: 4,
    name: 'Elizabeth Hendel',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'We have been very much impressed by what we\'ve seen. We would like to bless the founders Mr. & Mrs. Goud, the committed teachers and students. We hope blind children in Ethiopia will benefit much from our continued collaboration.',
    category: 'International'
  },
  {
    id: 5,
    name: 'Zinash Tayachew, Lensa Gudina, Tsegaye Milki, Zyobed Yonus',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'Thank you for the warm hospitality. I am amazed and touched by the kindness you have shown on these vulnerable children offering them a beautiful future. May you all be blessed with good health, love, and prosperity.',
    category: 'International'
  },
  {
    id: 6,
    name: 'Ms. Serey Chea',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'I simply could not believe my eyes at what I saw & experienced. How much easier for normal kids to learn than those visually impaired. Therefore, the visually impaired are only gifted. I am praising Dr. Saibaba & Jyothi for your efficiency and compassion. I am sure your children & their fortunes will continue the example you love.',
    category: 'International'
  },
  {
    id: 7,
    name: 'Christie Fij Richards',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'I had a divine experience, a learning that "A blind person does not need your sympathy, He or She needs opportunity." I am proud of Devnar Foundation for the Blind. Special Blessings to Padmasri Sai Baba Goud and the excellent Team.',
    category: 'Visitor'
  },
  {
    id: 8,
    name: 'C S Rangarajan',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'Very humbling experience to visit the school. World is a better place because of individuals like Dr. Goud.',
    category: 'Visitor'
  },
  {
    id: 9,
    name: 'Dr. P. Sarada P Sonty',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'Words truly fail to describe the wonderful and yeoman service being rendered to visually challenged boys at the Devnar School. Dr. Saibaba Goud and his staff have given hope to these children to face life with confidence. Wish them all the best.',
    category: 'Visitor'
  },
  {
    id: 10,
    name: 'K R Nandan',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'I am greatly humbled by the work of the Crusader Dr. Goud and of his caring staff. May all be blessed as members of the family of God.',
    category: 'Visitor'
  },
  {
    id: 11,
    name: 'Jim King',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'You are a blessing to all. Thank you for this.',
    category: 'Visitor'
  },
  {
    id: 12,
    name: 'Kirk Fischer',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'Amazing to see a great institution shaping young visually challenged students and making them agents of change. My best wishes and Congratulations for the foundation.',
    category: 'Visitor'
  },
  {
    id: 13,
    name: 'Prof. Srikrishna Deva Rao',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'Great visiting Devnar. Each visit is exciting. Great work by Dr. Saibaba garu. All the Best & all our support to you. God bless you.',
    category: 'Academic'
  },
  {
    id: 14,
    name: 'K. Taraka Ramarao',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'It is school for visually challenged. I am grateful to Dr. Goud and family to run the school for visually challenged regularly for several years.',
    category: 'Dignitary'
  },
  {
    id: 15,
    name: 'A. Narasimha Reddy',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'I am extremely happy an institution like this started by a visionary for the sake of visually challenged and it has been for the last twenty-two years progressing with more than 500 students from different parts of the country. All kudos to Mrs & Dr. Saibaba Goud and his team spirit.',
    category: 'Visitor'
  },
  {
    id: 16,
    name: 'Dr. K V Ramanachary',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'I have come after a gap of 12 years!! It is wonderful to see that this institution remains as energetic, passionate, and lively as before. It is good to know that despite all the challenges, the number of children and their success in the world has been continuously increasing.',
    category: 'Academic'
  },
  {
    id: 17,
    name: 'Shailaja R',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'It was a great pleasure to visit the school this morning. Congratulations on all the fantastic work being done, and may you continue serving the needy children of India. I will visit on my next trip.',
    category: 'Visitor'
  },
  {
    id: 18,
    name: 'Heather Hagstrom',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'The vision of Dr. Saibaba Goud has blossomed into this wonderful institution. Vision is more important than sight. Best wishes to the founder, staff and all the children.',
    category: 'International'
  },
  {
    id: 19,
    name: 'V.V.S. Laxman',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'Great experience to be at the school. I congratulate the foundation for the work they are doing to look after the needs of the visually challenged kids. I wish you all the very best. Keep it up.',
    category: 'Dignitary'
  },
  {
    id: 20,
    name: 'Mel Parker',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'This has been a tremendous visit. I am very proud of the Hyderabad Dell team and their focus and care for Devnar. Keep up the Good works.',
    category: 'Corporate'
  },
  {
    id: 21,
    name: 'Mrs. Petra Van De Waler',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'Shall I compare them to a normal child? You are more lovely and intelligent. It is visible in the children. They get quality education but also love and care in their interpersonal skills and cognitive skills. They are well groomed, well-mannered and friendly. This prepares them for future, that helps them, their families and the country of India.',
    category: 'International'
  },
  {
    id: 22,
    name: 'Harish Joshi',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'Very motivating, impressive and full of life. It has given me a lot of confidence and a feeling that the challenges we have are very insignificant when we complete proper training. Kudos to the management and the founder. My best wishes to the entire team of students. God Bless You all.',
    category: 'Visitor'
  },
  {
    id: 23,
    name: 'Alisan Fraser',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/01/empty-profile-300x300-1-126x126.jpg',
    message: 'Many thanks for your generous hospitality. You have a wonderful school and we look forward to sending more volunteers to you.',
    category: 'International'
  }
];

const CATEGORIES = [
  { id: 'all', label: 'All Visitors' },
  { id: 'International', label: 'International' },
  { id: 'Dignitary', label: 'Dignitaries' },
  { id: 'Academic', label: 'Academic' },
  { id: 'Corporate', label: 'Corporate' },
  { id: 'Educator', label: 'Educators' },
  { id: 'Visitor', label: 'Visitors' },
];

// --- Reusable Components ---

function Reveal({ as: Tag = 'div', className = '', delay = 0, children, ...rest }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [ref]);
  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? 'reveal-visible' : ''} ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : '0ms' }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

// --- Main VisitorsBook Component ---

export default function VisitorsBook() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredVisitors = VISITORS.filter(item => {
    const matchesCategory = selectedCategory === 'all' || item.category === selectedCategory;
    const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.message.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const totalVisitors = VISITORS.length;

  return (
    <>
      <Header />
      <div className="visitors-page devnar">
        <a className="skip-link" href="#main-visitors">Skip to main content</a>

        {/* --- Page Hero --- */}
        <section className="page-hero-visitors">
          <div className="hero-background">
            <div className="hero-overlay"></div>
            <div className="hero-pattern"></div>
          </div>
          <div className="wrap hero-content-visitors">
            <Reveal>
              <span className="hero-badge">Guestbook</span>
              <h1>Visitors Book</h1>
              <p className="hero-subtitle">
                Notes and messages from those who visited Devnar Foundation — 
                dignitaries, volunteers, educators, and well-wishers from around the world.
              </p>
            </Reveal>
          </div>
        </section>

        <main id="main-visitors" className="wrap page-content-visitors">

          {/* --- Stats --- */}
          <section className="visitors-stats">
            <div className="stats-grid">
              <div className="stat-card">
                <span className="stat-number">{totalVisitors}+</span>
                <span className="stat-label">Visitors</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">23+</span>
                <span className="stat-label">Countries</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">36+</span>
                <span className="stat-label">Years</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">100+</span>
                <span className="stat-label">Messages</span>
              </div>
            </div>
          </section>

          {/* --- Filter & Search --- */}
          <div className="visitors-filter-wrapper">
            <div className="filter-buttons">
              {CATEGORIES.map((category) => (
                <button
                  key={category.id}
                  className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category.id)}
                >
                  {category.label}
                </button>
              ))}
            </div>
            <div className="search-box">
              <input
                type="text"
                placeholder="Search visitors..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
              <span className="search-icon">🔍</span>
            </div>
          </div>

          {/* --- Visitors Grid --- */}
          <section className="visitors-grid-section">
            {filteredVisitors.length === 0 ? (
              <div className="no-results">
                <span className="no-results-icon">📖</span>
                <h3>No Visitors Found</h3>
                <p>Try adjusting your search or filter criteria.</p>
              </div>
            ) : (
              <div className="visitors-grid">
                {filteredVisitors.map((visitor, index) => (
                  <Reveal 
                    key={visitor.id} 
                    className="visitor-card" 
                    delay={(index % 12) * 40}
                  >
                    <div className="visitor-header">
                      <img src={visitor.image} alt={visitor.name} loading="lazy" />
                      <div className="visitor-info">
                        <h3>{visitor.name}</h3>
                        <span className="visitor-category">{visitor.category}</span>
                      </div>
                    </div>
                    <div className="visitor-message">
                      <span className="quote-mark">"</span>
                      <p>{visitor.message}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            )}
          </section>

          {/* --- Add Your Message --- */}
          <section className="add-message-section">
            <Reveal className="add-message-content" as="div">
              <span className="cta-eyebrow">Leave Your Mark</span>
              <h2>Visited Devnar?</h2>
              <p>
                We would love to hear about your experience. Share your thoughts and 
                become a part of our visitors book.
              </p>
              <a href="contacts.html" className="btn btn-primary">Share Your Message</a>
            </Reveal>
          </section>

        </main>
      </div>
      <Footer />
    </>
  );
}